import * as t from "io-ts";
import nullable from "./nullable";
import optional from "./optional";
export const trackerDeviceT = t.strict({
    id: t.string,
    deviceModel: t.number,
    deviceModelName: t.string,
    ident: t.string,
    phoneNumber: t.string,
    flespiId: nullable(t.number),
});
export const trackerDevicesT = t.strict({ data: t.array(trackerDeviceT) });
export const positionRouteT = t.strict({
    id: t.number,
    begin: t.number,
    end: t.number,
    duration: t.number,
    route: t.string,
    timestamp: t.number,
});
export const routeStatsT = t.strict({
    totalFuelConsumption: t.number,
});
export const positionRoutesT = t.array(positionRouteT);
export const flespiMessageT = t.strict({
    timestamp: t.number,
    stopTimeInSeconds: t.union([t.number, t.undefined]),
    "position.latitude": t.number,
    "position.longitude": t.number,
    "position.speed": optional(t.number),
    "engine.ignition.status": optional(t.boolean),
    "can.fuel.consumption": t.union([t.number, t.undefined, t.null]),
});
export const flespiMessagesT = t.array(flespiMessageT);
//# sourceMappingURL=tracker-devices.js.map